import type Luminary from '../..';
import type { FrameExtractor } from '../types';
import { Frame } from '../frame';

/**
 * Instead of reading pixels from luminary, we pass reference to canvas.
 */
export class VideoFrameExtractor implements FrameExtractor<HTMLCanvasElement> {
    async extractFrame(luminary: Luminary): Promise<Frame<HTMLCanvasElement>> {
        const canvas = luminary.canvas;
        return new Frame(canvas, () => {});
    }
}
